/**
 * JavaScript Document
 * Version: 1.0.0
 * Date: 4/14/2020
 * Author: Liu Changkun
 * Copyright: www.east.net
 */

// { value: 1, name: "无", canadd: true },
// { value: 2, name: "列表", canadd: false },
// { value: 3, name: "单页", canadd: false },
// { value: 4, name: "三维图", canadd: true },
// { value: 5, name: "选项卡", canadd: false }

import config from '../api/config'

import layout from '@/pages/front/components/layout';
import singlePage from '@/pages/front/components/single-page';
import threeDPage from '@/pages/front/components/threeD-page';
import listPage from '@/pages/front/components/list-page';
import tabPage from '@/pages/front/components/tab-page';
let container = {render: c=>c("router-view")};

export function getProductsRoutes() {
    let routes = [];
    let xhr = new XMLHttpRequest();
    xhr.open("GET", config.baseURL + "/api/gm/routes/get?r=" + Math.random(), false);
    xhr.onload = function () {
        if (this.status === 200) {
            let result = JSON.parse(this.responseText);
            if (result.code === 0) {

                routes = processRoute(result.data);
            
            }
        }
    };
    xhr.send();

    function processRoute(data) {
        // 内容分组
        let contents = {};
        data.catalogs.forEach(catalog => contents[catalog.id] = {});
        data.infos.forEach(info => {
            if (contents[info.productID]) {
                let list;
                if (contents[info.productID][info.relationID]) {
                    list = contents[info.productID][info.relationID];
                } else {
                    list = contents[info.productID][info.relationID] = [];
                }
                list.push(info)
            }
        });

        // 内容排序
        for (let pid in contents) {
            if (contents.hasOwnProperty(pid)) {
                for (let rid in contents[pid]) {
                    if (contents[pid].hasOwnProperty(rid)) {
                        contents[pid][rid].sort((a, b) => a.sort - b.sort);
                    }
                }
            }
        }

        return data.catalogs.map(catalog => {
            let route = {
                path: `/tools/${catalog.id}`,
                component: layout,
                meta: {
                    pid: catalog.id,
                    title: catalog.name,
                    tree: []
                },
                children: []
            };
            try {
                let children = JSON.parse(catalog.catalog)[0].children;
                if (children.length) {
                    route.children = processChildren(children, catalog.id, contents[catalog.id]);
                    route.redirect = `${route.path}/${route.children[0].path}`;
                    route.meta.tree = children;
                }
            } catch (e) {
                console.error(e)
            }
            return route;
        });
    }

    function processChildren(children, pid, contents) {
        if (!children || !children.length) {
            return [];
        }
        return children.map(child => {
            let route = {
                path: child.id.toString(),
                children: processChildren(child.children, pid, contents),
                component: container,
                meta: {
                    pid,
                    rid: child.id,
                    title: child.label
                }
            };

            let carr=saixuan(child.type,contents[child.id]);
            // 设置重定向
            if (child.type === 1 && route.children.length) {
                route.redirect = `${route.path}/${route.children[0].path}`
            } else {
            
                route.children.unshift({
                    path: "",
                    component: getComponent(child.type),
                    meta: {
                        pid,
                        rid: child.id,
                        cid:carr && carr[0] && carr[0].id, //contents[child.id] && contents[child.id][0] && contents[child.id][0].id,
                        list: carr
                    }
                })

                // 设置3D展示页列表
                if (child.type === 4){
                  route.children[0].meta.threeDList = route.children.slice(1);
                }
            }

            // 设置内容页路由
            //if (contents[child.id]) {
               // contents[child.id].forEach(content => {
                  if (carr) {
                    carr.forEach(content => {
                    route.children.push({
                        path: content.id.toString(),
                        component: singlePage,
                        meta: {
                            pid,
                            rid: child.id,
                            cid: content.id,
                            title: content.title
                        }
                    });
                });
            }
            return route;
        })
    }

    function getComponent(type) {
        switch (type) {
            case 2:
                return listPage;
            case 3:
                return singlePage;
            case 4:
                return threeDPage;
            case 5:
                return tabPage;
            default:
                return container;
        }
    }

function saixuan(type,arr)
{

  if(arr!=undefined && (type==2 ||type==3||type==5))
  {
  let newArr= [];
  for(var i = 0; i < arr.length; i++) {

    if (type==2 && arr[i].relationModel=='list')
    {
      newArr.push(arr[i]);
     
    }else if (type==3 && arr[i].relationModel=='info')
    {
      newArr.push(arr[i]);
     
    }   else if (type==5 && arr[i].relationModel=='tab')
    {
      newArr.push(arr[i]);
    }
       
  }
if(newArr.length<1)
{
  return undefined;
}
else
{

return newArr;
}
  }
  else
  {
    return arr;
  }

}


    return routes;
}

export function treeSame(a, b) {
    if(!a || !b || a.length !== b.length){
        return false;
    }
    for (let i = 0; i < a.length; i++) {
        if(a[i].id !== b[i].id || a[i].label !== b[i].label || !treeSame(a[i].children, b[i].children)){
            return false;
        }
    }
    return true
}



// WEBPACK FOOTER //
// ./src/router/product.js